export default function (vm) {
    return {
        Profile: {
            click: function () {
                vm.$emit("open-profile")
            }
        },
        Reload: {
            click: function () {
                const cProps = vm.userProfileData["Reload"]
                console.log("Click Before", cProps.reloadFlag);
                cProps.reloadFlag = !cProps.reloadFlag;
                console.log("Click After", cProps.reloadFlag);
                vm.$emit("Reload");
            }
        },
        SignOut: {
            click: function () {
                vm.$emit("sign:out")
            }
        }
    }
}